import { connect } from 'react-redux';
import { Instances } from '../../../../constants';
import { IStateType } from '../../../../store/models/root.interface';
import { requestObject } from '../../../../store/Object';
import { closeSideBar, getParams } from '../../../../store/sidebar';
import ViewApiKey, { DispatchPropsType, MapStatePropsType } from '../organisms/ViewApiKey';

const mapStateToProps = (state: IStateType) => ({
	params: getParams(state)
});
const mapDispatchToProps = {
	onClose: () => {
		return closeSideBar();
	},
	getApiKeyDetails: (data: any, callBack: any) =>
		requestObject(
			Instances.apiKeys,
			undefined,
			data,
			'GET',
			true,
			true,
			{},
			callBack
		)
};

export default connect<MapStatePropsType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(ViewApiKey);
